import { render } from "./MMContactNavbar.vue?vue&type=template&id=2cd8e4d9"
import script from "./MMContactNavbar.vue?vue&type=script&lang=js"
export * from "./MMContactNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__